import React, { useEffect, useState } from "react";
import useTelegram from "../hooks/telegram-hook";
import "../styles/main.css";
import UserApi from "../services/api-service";
import { separateNumber } from "utils/helpers";

/**
 * Компонент страницы "Профиль".
 * Отвечает за получение данных пользователя и отображение карточки профиля.
 */
function Main(): JSX.Element {
  const telegram = useTelegram();
  const { first_name: firstName = "test", id: userId = "1938421476" } =
    telegram?.user || {};

  const [balanceStr, setBalanceStr] = useState("0");
  const [gemsCount, setGemsCount] = useState(0);
  const [keysCount, setKeysCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [mediaType, setMediaType] = useState<"image" | "video">("image");
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setIsLoading(true);
        const { Balance, Gems, Chests } = await UserApi.getUser(userId);
        setBalanceStr(separateNumber(Balance));
        setGemsCount(Number(Gems) || 0);
        setKeysCount(Number(Chests) || 0);
      } catch (err) {
        console.error("Не удалось загрузить данные пользователя:", err);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchAvatar = async () => {
      try {
        // ⚙️ Явно запрашиваем формат с прозрачным фоном
        const response = await fetch(
          `https://pablohouse.su:88/getPhoto?userId=${userId}&format=webm`
        );
        const contentType = response.headers.get("content-type") || "";

        if (contentType.includes("video")) {
          setMediaType("video");
        } else {
          setMediaType("image");
        }

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        setAvatarUrl(objectUrl);
      } catch (err) {
        console.error("Ошибка загрузки аватара:", err);
      }
    };

    fetchUserData();
    fetchAvatar();

    return () => {
      if (avatarUrl) URL.revokeObjectURL(avatarUrl);
    };
  }, [userId]);

  return (
    <div className="app-root">
      <main className="profile-page">
        <section className="profile-card">
          <div className="avatar-wrap">
            {avatarUrl &&
              (mediaType === "video" ? (
                <video
                  src={avatarUrl}
                  className="avatar-img"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              ) : (
                <img
                  src={avatarUrl}
                  alt="аватар пользователя"
                  className="avatar-img"
                />
              ))}
          </div>

          <div className="profile-content">
            <h1 className="nickname">{firstName.toUpperCase()}</h1>

            {isLoading ? (
              <div className="stats-loading">Загрузка...</div>
            ) : (
              <ul className="stats-list">
                <li className="stats-item">
                  <span className="stats-label">Старки</span>
                  <span className="stats-value">{balanceStr}</span>
                </li>
                <li className="stats-item">
                  <span className="stats-label">Гемы</span>
                  <span className="stats-value">{gemsCount}</span>
                </li>
                <li className="stats-item">
                  <span className="stats-label">Ключи</span>
                  <span className="stats-value">{keysCount}</span>
                </li>
              </ul>
            )}
          </div>
        </section>
      </main>
    </div>
  );
}

export default Main;
